import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import moment from "moment/moment.js";
import SportSolutionApiWrapper from "../utils/SportSolutionApiWrapper";

class BookingButton extends Component {
  constructor() {
    super();
    this.changeBooking = this.changeBooking.bind(this);
    this.disabled = this.disabled.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.state = {
      disabled: false,
      buttonText: "",
      i18nKeeper: document.querySelector("#i18n").dataset,
    };
  }

  componentWillMount() {
    this.setState({ booking: this.props.booking });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ booking: nextProps.booking });
    if (nextProps.centers) {
      this.setState({ centers: nextProps.centers });
    }
  }

  changeBooking(e) {
    const booking = this.props.booking;
    if (this.disabled()) return;
    let ssaw = new SportSolutionApiWrapper();
    let that = this;
    const event = this.props.event;

    if (booking) {
      this.disableButton(this.state.i18nKeeper.canceling);
      ssaw.cancel(
        booking.id,
        function(resp) {
          that.enableButton();
          that.setState({ booking: null });
          that.props.getBookings();
        },
        function(error_resp) {
          that.enableButton();
          alert(this.state.i18nKeeper.error);
        },
      );
    } else {
      if (
        moment(this.props.event.start_date_time).subtract(2, "hours") > moment() ||
        confirm(this.state.i18nKeeper.booking_within_two_hours)
      ) {
        this.disableButton(this.state.i18nKeeper.booking);
        ssaw.book(
          event.id,
          function(resp) {
            that.enableButton();
            if (resp.ss_participation) {
              that.setState({ booking: { can_cancel: true } });
              that.props.getBookings();
            } else {
              if (resp.error) {
                that.props.popup(resp.error);
              } else {
                that.props.popup(that.state.i18nKeeper.error);
              }
            }
          },
          function(error_resp) {
            that.enableButton();
            if (error_resp && error_resp.responseJSON && error_resp.responseJSON.error) {
              that.props.popup(error_resp.responseJSON.error);
            } else {
              that.props.popup(that.state.i18nKeeper.error);
            }
          },
        );
      }
    }
  }
  disabled() {
    return (
      this.state.disabled ||
      (this.state.booking && !this.state.booking.can_cancel) ||
      (!this.state.booking && this.props.event && !this.props.event.can_book)
    );
  }
  disableButton(buttonText) {
    this.setState({ disabled: true });
    this.setState({ buttonText: buttonText });
  }
  enableButton() {
    this.setState({ disabled: false });
  }
  buttonText() {
    if (this.state.disabled) {
      return this.state.buttonText;
    } else {
      return this.state.booking ? this.state.i18nKeeper.cancel : this.state.i18nKeeper.book;
    }
  }
  render() {
    if (!this.props.event && !this.state.booking) return <div />;
    let name = "";
    if (this.props.showName && this.state.booking) {
      let centerName = this.props.getCenterNameById(this.state.booking.centerId);
      name = `${moment(this.state.booking.start).format("DD.MM HH:00")} ${
        this.state.booking.name
      } (${centerName})`;
    }

    return (
      <div>
        <span className="right-padding">{name}</span>
        <Button
          onClick={e => this.changeBooking(e)}
          disabled={this.disabled()}
          ref="button"
          className={this.state.booking ? "frameld booking" : "booking"}
        >
          {this.buttonText()}
        </Button>
      </div>
    );
  }
}

BookingButton.propTypes = {
  booking: PropTypes.object,
  getBookings: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  event: PropTypes.object,
  getCenterNameById: PropTypes.func,
};

export default BookingButton;
